export default __webpack_public_path__ + "static/ATMaps_hero_video_1920x640_hb2-897f6d3ae2e8368c318150e3f72ee697.mp4";